/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Template_Read_OnlyInputs */

const en_error_template_read_only = /** @type {(inputs: Error_Template_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email carries a one-time link: its text changes only with a release of Nexxt.`)
};

/**
* | output |
* | --- |
* | "This email carries a one-time link: its text changes only with a release of Nexxt." |
*
* @param {Error_Template_Read_OnlyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_template_read_only = /** @type {((inputs?: Error_Template_Read_OnlyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Template_Read_OnlyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_template_read_only(inputs)
});